export default (initialState = {}) => {
  return () => {
    return {
      _id: "",
      credit_score: "",
      delinquencies: "",
      balance: "",
      overdraft: [],
      ...initialState,
    };
  };
};
